import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { colors } from 'bench-style-constants';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: auto 50px 1fr;
  align-items: center;
  font-size: 16px;
`;

const DateSeparator = styled.div`
  font-size: 12px;
  color: ${colors.charcoal};
  text-align: center;
`;

const DateMonth = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: ${colors.water};
`;

const DateYear = styled.div`
  font-size: 12px;
  color: ${colors.dust};
  line-height: 1;
`;

type HistoryDateProps = {
  date: string;
};

const HistoryDate = ({ date }: HistoryDateProps) => {
  const dateParsed = moment(date, 'YYYY-MM');
  return (
    <div>
      <DateMonth>{dateParsed.format('MMMM')}</DateMonth>
      <DateYear>{dateParsed.year()}</DateYear>
    </div>
  );
};

type DateRangeProps = {
  fromDate: string;
  toDate: string;
};

const DateRange = ({ fromDate, toDate }: DateRangeProps) => {
  if (fromDate === toDate) {
    return <HistoryDate date={fromDate} />;
  }

  // The wrapping div ensures that the component doesn't fill the parent component verically.
  // This ensures that our align-items: center works as expected for the wrapper.
  return (
    <div>
      <Wrapper>
        <HistoryDate date={fromDate} />
        <DateSeparator> to </DateSeparator>
        <HistoryDate date={toDate} />
      </Wrapper>
    </div>
  );
};

export default DateRange;
